import createFormValueSelector from './createFormValueSelector';
import plain from './structure/plain';

export default createFormValueSelector(plain);


//////////////////
// WEBPACK FOOTER
// ../node_modules/redux-form/es/formValueSelector.js
// module id = 1326
// module chunks = 0